import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import LoginPage from "./login-page";

interface Props {
    component: React.ComponentType;
}

export const AuthenticationGuard: React.FC<Props> = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div>
        <LoginPage />
      </div>
    ),
  });

  return <Component />;
};